import { render } from "./Mo_CurrencyInput.vue?vue&type=template&id=674914c8&ts=true"
import script from "./Mo_CurrencyInput.vue?vue&type=script&lang=ts"
export * from "./Mo_CurrencyInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__